var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_html.js
// module id = 48
// module chunks = 0